import React from "react";
import { getFormattedTime } from "../../util/util";
import { StyledItemContainer, StyledTimeLabel } from "./SpeechBlock";
import styled from "styled-components";

const StyledBreak = styled(StyledItemContainer)`
    color: ${({ theme }) => theme.colors.white};
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colors.white};
    border-left: none;
    border-right: none;
    text-transform: uppercase;
`;

const Break = ({ item }) => {
    return (
        <StyledItemContainer>
            <StyledTimeLabel>{getFormattedTime(item.startTime, "h")}</StyledTimeLabel>
            <StyledBreak fontSize={[2, 3]} paddingY={3} fontWeight="bold">
                {item.label}
            </StyledBreak>
        </StyledItemContainer>
    );
};

export default Break;
